// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DialogConfirm_dialog__1SfME","mask":"DialogConfirm_mask__1J8S6","body":"DialogConfirm_body__3uniz","dialogVisible":"DialogConfirm_dialogVisible__6CgNH"};